import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

export interface SabalDispatchAssignedEvent {
  data?: {
    orgName?: string;
  };
}

export const SabalDispatchAssigned = ({ event }: { event: SabalDispatchAssignedEvent }) => {
  const orgDisplay = event?.data?.orgName ?? 'Organization';
  return (
    <Box display="block">
      <EventBy event={event} /> assigned dispatch to {orgDisplay}
    </Box>
  );
};

export default SabalDispatchAssigned;
